import { render, staticRenderFns } from "./relegation_rules.vue?vue&type=template&id=65081285&scoped=true"
import script from "./relegation_rules.vue?vue&type=script&lang=js"
export * from "./relegation_rules.vue?vue&type=script&lang=js"
import style0 from "./relegation_rules.vue?vue&type=style&index=0&id=65081285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65081285",
  null
  
)

export default component.exports